import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { CandidateJobMatchesWorkflowPageComponent } from './candidate-job-matches-workflow-page.component';
import { CandidateJobMatchesWorkflowModule } from './candidate-job-matches-workflow/candidate-job-matches-workflow.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.candidateJobMatchesWorkflow',
    url: '/candidateJobMatchesWorkflow',
    component: CandidateJobMatchesWorkflowPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      jobId: null,
      jobMatchId: null,
      searchString: null,
      visibilityFiltersObject: null,
      reqStateData: null
    }
  }
];

@NgModule({
  declarations: [CandidateJobMatchesWorkflowPageComponent],
  imports: [
    CommonModule,
    CandidateJobMatchesWorkflowModule,
    UIRouterModule.forChild({ states })
  ],
  entryComponents: [CandidateJobMatchesWorkflowPageComponent],
  exports: [CandidateJobMatchesWorkflowPageComponent]
})
export class CandidateJobMatchesWorkflowPageModule { }
